import { render, staticRenderFns } from "./beneficiary-bt-details.vue?vue&type=template&id=e682e014&"
import script from "./beneficiary-bt-details.vue?vue&type=script&lang=js&"
export * from "./beneficiary-bt-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports